import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeuser',
  templateUrl: './homeuser.component.html',
  styleUrls: ['./homeuser.component.css']
})
export class HomeuserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
